import { GREEN, BLACK, GREEN_LIGHT } from './constants';

export const F = 'system-ui, -apple-system, sans-serif';

export const mono = { fontFamily: 'monospace', fontSize: 11, color: '#999' };

export const labelSt = {
  fontSize: 10, fontWeight: 700, letterSpacing: 1,
  textTransform: 'uppercase', color: '#999',
  marginBottom: 6, fontFamily: 'monospace',
};

export const card = (extra = {}) => ({
  background: '#fff',
  border: '1.5px solid #e0e0d8',
  borderRadius: 14,
  padding: 20,
  ...extra,
});

export const cardGreen = (extra = {}) => ({
  background: GREEN,
  border: `1.5px solid ${GREEN}`,
  borderRadius: 14,
  padding: 20,
  ...extra,
});

export const cardBlack = (extra = {}) => ({
  background: BLACK,
  border: `1.5px solid ${BLACK}`,
  borderRadius: 14,
  padding: 20,
  color: '#fff',
  ...extra,
});

export const inputSt = (readOnly = false) => ({
  width: '100%',
  padding: '9px 11px',
  borderRadius: 9,
  border: '1.5px solid #e0e0d8',
  fontSize: 13,
  outline: 'none',
  marginBottom: 12,
  fontFamily: F,
  background: readOnly ? '#f8f8f6' : '#fff',
  boxSizing: 'border-box',
});
